var _defs, _polygon, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack362({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "10.19 9.06 10.19 8.83 10.19 7.17 10.19 6.94 5.51 6.22 5.51 7.89 5.51 8.11 5.51 9.78 10.19 9.06"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 10.19,
    y: 5.27,
    width: 5.46,
    height: 5.46,
    transform: "translate(25.84 16) rotate(180)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.46,12.32a5.48,5.48,0,0,1,0-8.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.23,11.64a4.46,4.46,0,0,1,0-7.28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.46,3.68a5.48,5.48,0,0,0,0,8.64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.23,4.36a4.46,4.46,0,0,0,0,7.28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,11A3.48,3.48,0,0,1,4,5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.86,10.2a2.41,2.41,0,0,1,0-4.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,5A3.48,3.48,0,0,0,4,11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.86,5.8a2.41,2.41,0,0,0,0,4.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack362);
export default __webpack_public_path__ + "static/media/Symbol_pack_362.a94376969aa826b819e766ff2e2b5dc6.svg";
export { ForwardRef as ReactComponent };